import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { WarningLocationItemLink } from './location.item.link.js';
import { IWarningLocationProps } from './warnings-table.entry.js';

export interface IWarningLocationItem {
  filteredWarnings: IWarning[];
  location: IWarningLocationProps;
}

/** 3 states here no warnings, warnings but no link, warnings and link */
export const WarningLocationItem = ({ filteredWarnings, location }: IWarningLocationItem) => {
  const locationWarnings = filteredWarnings.filter((f) => f.iceLocation === location.iceLocation);
  const warningIcon = locationWarnings.find((l) => l.icon);
  if (!warningIcon) {
    return (
      <li className="LocationList-item">
        <WarningLocationItemLink filteredWarnings={filteredWarnings} location={location}>
          <p className="u-mT-xs u-mB-xs">{location.label}</p>
        </WarningLocationItemLink>
      </li>
    );
  }
  return (
    <li className="LocationList-item">
      <WarningLocationItemLink filteredWarnings={filteredWarnings} location={location}>
        <IconWithText
          icon={`${String(warningIcon.icon)}-${warningIcon.warnLevel}` as IconNameV1}
          classes="IconWithText--vCenter"
        >
          {location.label}
        </IconWithText>
      </WarningLocationItemLink>
    </li>
  );
};
